


























































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import BarChartComponent from '@/components/BarChartComponent.vue'
import Chart from "chart.js"
import DashBoardService from '@/service/DashBoardService'
import { DashBoard } from '@/domain/DashBoard'

const FONT_COLOR = "rgba(0, 0, 0, 1)"
const GRID_LINES_SETTING = {
  display: true,
  drawOnChartArea: false,
  color: "rgba(0, 0, 0, .5)",
  zeroLineColor: "rgba(0, 0, 0, 1)"
}

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    BarChartComponent,
  },
})
export default class MemberDashBoard extends Mixins(GlobalMixin) {
  dashBoardService = DashBoardService.instance

  dashBoard: DashBoard = new DashBoard()
  monthlyChartOptions: Chart.ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      fullWidth: false,
      labels: {
        boxWidth: 20,
        fontColor: FONT_COLOR
      },
    },
    layout: {
      padding: {
        top: 20,
        left: 20,
        bottom: 20,
        right: 20
      }
    },
    scales: {
      xAxes: [
        {
          gridLines: GRID_LINES_SETTING,
          ticks: {
            autoSkip: true,
            fontColor: FONT_COLOR,
            fontSize: 14
          },
          scaleLabel: {
            display: true,
            fontColor: FONT_COLOR,
            labelString: "年/月",
          },
        },
      ],
      yAxes: [
        {
          id: "requestCount",
          type: "linear",
          gridLines: GRID_LINES_SETTING,
          scaleLabel: {
            display: true,
            fontColor: FONT_COLOR,
            labelString: "件"
          },
          ticks: {
            autoSkip: true,
            fontColor: FONT_COLOR,
            fontSize: 14,
            min: 0,
          },
          position: "right"
        },
        {
          id: "amount",
          type: "linear",
          gridLines: GRID_LINES_SETTING,
          scaleLabel: {
            display: true,
            fontColor: FONT_COLOR,
            labelString: "万円"
          },
          ticks: {
            autoSkip: true,
            fontColor: FONT_COLOR,
            fontSize: 14,
            min: 0,
          },
        },
      ],
    }
  }
  monthlyChartData: Chart.ChartData = {}

  userSalesChartOptions: Chart.ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      fullWidth: false,
      labels: {
        boxWidth: 20,
        fontColor: FONT_COLOR
      },
    },
    layout: {
      padding: {
        top: 20,
        left: 20,
        bottom: 20,
        right: 20
      }
    },
    scales: {
      xAxes: [
        {
          gridLines: GRID_LINES_SETTING,
          ticks: {
            autoSkip: true,
            fontColor: FONT_COLOR,
            fontSize: 14
          },
          scaleLabel: {
            display: true,
            fontColor: FONT_COLOR,
            labelString: "担当者",
          },
        },
      ],
      yAxes: [
        {
          id: "amount",
          type: "linear",
          gridLines: GRID_LINES_SETTING,
          scaleLabel: {
            display: true,
            fontColor: FONT_COLOR,
            labelString: "万円"
          },
          ticks: {
            autoSkip: true,
            fontColor: FONT_COLOR,
            fontSize: 14,
            min: 0,
          },
        },
      ],
    }
  }
  userSalesChartData: Chart.ChartData = {}

  mounted () {
    this.dashBoardService.info()
      .then((x) => {
        x.monthSalesAmounts = x.monthSalesAmounts.filter(y => (y.ordersAmount + y.expectedSalesAmount + y.salesAmount + y.salesAmount + y.requestCount) !== 0)
        this.dashBoard = x
        this.createChart()
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
      })
  }

  /**
   * グラフの更新
   */
  createChart() {
    this.monthlyChartData = this.createMonthlyChart()
    this.userSalesChartData = this.createUserSalesChart()
  }

  /**
   * 月次推移グラフの更新
   */
  createMonthlyChart(): Chart.ChartData {
    const labels = this.dashBoard.monthSalesAmounts.map(x => x.yearMonth)
    const requestCount = this.dashBoard.monthSalesAmounts.map(x => x.requestCount)
    const expectedSalesAmount = this.dashBoard.monthSalesAmounts.map(x => Math.floor(x.expectedSalesAmount / 10000))
    const ordersAmount = this.dashBoard.monthSalesAmounts.map(x => Math.floor(x.ordersAmount / 10000))
    const salesAmount = this.dashBoard.monthSalesAmounts.map(x => Math.floor(x.salesAmount / 10000))

    return {
      labels: labels,
      datasets: [
        {
          yAxisID: "requestCount",
          type: "line",
          label: "依頼件数",
          backgroundColor: "#F87979",
          borderColor: "#F87979",
          fill: false,
          lineTension: 0,
          data: requestCount
        },
        {
          yAxisID: "amount",
          type: "bar",
          label: "受注金額",
          backgroundColor: "#4DB6AC",
          borderColor: "#4DB6AC",
          fill: false,
          data: ordersAmount
        },
        {
          yAxisID: "amount",
          type: "bar",
          label: "売上見込金額",
          backgroundColor: "#4DD0E1",
          borderColor: "#4DD0E1",
          fill: false,
          data: expectedSalesAmount
        },
        {
          yAxisID: "amount",
          type: "bar",
          label: "売上金額",
          backgroundColor: "#6090EF",
          borderColor: "#6090EF",
          fill: false,
          data: salesAmount
        },
      ]
    }
  }

  /**
   * 担当別売上グラフの更新
   */
  createUserSalesChart(): Chart.ChartData {
    const labels = this.dashBoard.userSalesAmounts.map(x => x.userName)
    const salesAmount = this.dashBoard.userSalesAmounts.map(x => Math.floor(x.salesAmount / 10000))

    return {
      labels: labels,
      datasets: [
        {
          yAxisID: "amount",
          type: "bar",
          label: "売上金額",
          backgroundColor: "#6090EF",
          borderColor: "#6090EF",
          fill: false,
          data: salesAmount
        },
      ]
    }
  }

}
